import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import BookButton from "./BookButton";
import { clinics, memberships, nav, site } from "@/content";

export default function Footer() {
  return (
    <footer className="bg-forest text-cream/85" data-testid="site-footer">
      <div className="container-np grid gap-12 py-16 md:grid-cols-12 md:py-20">
        <div className="md:col-span-4">
          <p className="font-serif text-3xl text-cream">Nordic Prolo</p>
          <p className="mt-2 text-sm">{site.tagline} i Nacka och Göteborg.</p>
          <BookButton testId="footer-book-button" className="mt-6" />
        </div>
        <nav aria-label="Sidfot" className="md:col-span-2">
          <h2 className="footer-h">Sidor</h2>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/" className="footer-link" data-testid="footer-link-start">Start</Link></li>
            {nav.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="footer-link" data-testid={`footer-link-${n.to.slice(1)}`}>{n.label}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="md:col-span-3">
          <h2 className="footer-h">Mottagningar</h2>
          <ul className="mt-4 space-y-4 text-sm">
            {clinics.map((c) => (
              <li key={c.id}>
                <span className="block font-semibold text-cream">{c.city}</span>
                {c.addressLines.map((l) => <span key={l} className="block">{l}</span>)}
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <h2 className="footer-h">Kontakt</h2>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href={site.phone.href} className="footer-link" data-testid="footer-phone-link">{site.phone.display}</a></li>
            <li><a href={site.email.href} className="footer-link" data-testid="footer-email-link">{site.email.display}</a></li>
            <li>
              <a href={site.instagram.href} target="_blank" rel="noopener noreferrer" className="footer-link inline-flex items-center gap-1" data-testid="footer-instagram-link">
                Instagram {site.instagram.display} <ArrowUpRight className="h-3.5 w-3.5" />
              </a>
            </li>
          </ul>
          <h2 className="footer-h mt-8">Dr Hivar Kaftan är medlem i</h2>
          <ul className="mt-3 space-y-1 text-sm">
            {memberships.map((m) => (
              <li key={m.name}>
                <a href={m.url} target="_blank" rel="noopener noreferrer" className="footer-link">{m.name}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="container-np flex flex-col gap-2 py-6 text-xs text-cream/60 sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} {site.name}</span>
          <span>Demo skapad av Elido</span>
        </div>
      </div>
    </footer>
  );
}
